import { __assign, __generator } from "tslib";
import { put, takeLatest, call, select, delay } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { PUBLISH_COMMENT, publishCommentSuccess, publishCommentFailure, focusEditor, focusEditorWithScroll, } from './actionCreators';
import { request } from '../xhr';
import { RequestError, } from './types';
import { getIsLoggedIn, getIsMobile, getIsVerificationNeeded, } from '../publicSession/selectors';
import { convertToServerXhrPayload } from '../DaEditorWrapper/utils';
import { addNotification } from '../Notifications/redux/actionCreators';
import { NotificationType } from '../Notifications/redux/types';
import { restrictLoggedOut } from '../redux/loggedout';
import { flagEnabled } from '../redux/flags/selectors';
import { scrollIntoViewWithHeader } from '../utils/scrollIntoViewWithHeader';
import { pushVerificationPopup } from '../VerificationPopup/actions';
import { ReferralType } from '../biLogger';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        // eslint-disable-next-line
        var comments = require('@wix/da-sample-data').comments;
        var comment = comments[0];
        if (options.url === '/comments/post') {
            comment.posted = Date.now();
            comment.likes = 0;
            comment.isAuthor = true;
            var body = {
                excerpt: '',
                html: {
                    type: 'draft',
                    markup: options.data.editorRaw,
                    features: '',
                },
            };
            comment.textContent = body;
        }
        if (options.data.parentid) {
            comment.parentId = options.data.parentid;
        }
        if (options.data.commentid) {
            comment.commentId = options.data.commentid;
        }
        return comment;
    }
}
function getError(result) {
    if (result &&
        result.error_code !== undefined &&
        RequestError[result.error_code] !== undefined) {
        return { error: result.error_code, errorMsg: result.error_description };
    }
    return {
        error: RequestError.GeneralError,
        errorMsg: result.error_description,
    };
}
export function publishCommentHandler(action) {
    var _a, editorContent, rawContentState, featuresData, editComment, replyComment, typeId, itemId, editorId, _b, isLoggedIn, isVerificationNeeded, postData, result, publishResult, enableCommentNotifications;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, editorContent = _a.editorContent, rawContentState = _a.rawContentState, featuresData = _a.featuresData, editComment = _a.editComment, replyComment = _a.replyComment, typeId = _a.typeId, itemId = _a.itemId, editorId = _a.editorId;
                return [4 /*yield*/, select(function (state) { return ({
                        isLoggedIn: getIsLoggedIn(state),
                        isVerificationNeeded: getIsVerificationNeeded(state),
                    }); })];
            case 1:
                _b = _c.sent(), isLoggedIn = _b.isLoggedIn, isVerificationNeeded = _b.isVerificationNeeded;
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.COMMENT_ACTION }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                if (!isVerificationNeeded) return [3 /*break*/, 5];
                return [4 /*yield*/, put(pushVerificationPopup('comment'))];
            case 4:
                _c.sent();
                return [2 /*return*/];
            case 5:
                postData = __assign({ typeid: typeId, itemid: itemId }, convertToServerXhrPayload(rawContentState, editorContent, featuresData));
                ddt.log('comments', 'posting a comment', postData);
                if (editComment) {
                    postData.commentid = editComment.commentId;
                }
                if (replyComment) {
                    postData.parentid = replyComment.commentId;
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/comments/post",
                        data: postData,
                    }, fakeResponse)];
            case 6:
                result = _c.sent();
                if (!(result && !result.error)) return [3 /*break*/, 11];
                publishResult = {
                    editorId: editorId,
                    comment: result,
                };
                return [4 /*yield*/, put(publishCommentSuccess(publishResult))];
            case 7:
                _c.sent();
                return [4 /*yield*/, select(flagEnabled, 'comment_scroll_top')];
            case 8:
                enableCommentNotifications = _c.sent();
                if (!enableCommentNotifications) return [3 /*break*/, 10];
                return [4 /*yield*/, put(addNotification(NotificationType.PostComment, {}))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, put(publishCommentFailure(__assign({ editorId: editorId }, getError(result))))];
            case 12:
                _c.sent();
                _c.label = 13;
            case 13: return [2 /*return*/];
        }
    });
}
export function focusHandler(_a) {
    var editor, isMobile;
    var _b = _a.payload, editorId = _b.editorId, smoothScroll = _b.smoothScroll;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                editor = document.getElementById(editorId);
                return [4 /*yield*/, select(getIsMobile)];
            case 1:
                isMobile = _c.sent();
                if (!editor) return [3 /*break*/, 4];
                scrollIntoViewWithHeader(editor, isMobile, 100, undefined, smoothScroll);
                return [4 /*yield*/, delay(500)];
            case 2:
                _c.sent();
                return [4 /*yield*/, put(focusEditor(editorId))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(PUBLISH_COMMENT, publishCommentHandler)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(focusEditorWithScroll, focusHandler)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map